import { useState, useEffect, SyntheticEvent } from 'react';
import { useLocation, useParams, Link } from 'react-router-dom';
import { Box, Tabs, Tab } from '@mui/material';

import { IDynamicTabLink } from '../../../../interfaces/dynamic-tab.interface';

const DynamicTabLink = ({ tabs }: { tabs: IDynamicTabLink[] }) => {
  const { slug } = useParams();
  const { pathname } = useLocation();

  const [value, setValue] = useState<number>(0);

  useEffect(() => {
    tabs.map((tab: IDynamicTabLink, i) => {
      tab.to && tab.to(slug) === pathname && setValue(i);
    });
  }, [tabs]);

  const handleChange = (e: SyntheticEvent, newVal: number) => {
    setValue(newVal);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} variant='scrollable' scrollButtons='auto'>
          {tabs.map((tab: IDynamicTabLink, index: number) => (
            <Tab key={index} label={tab.label} component={Link} to={tab.to(slug)} />
          ))}
        </Tabs>
      </Box>
    </Box>
  );
};

export default DynamicTabLink;
